// save token

export const VALIDATE_ACCESS_TOKEN_REQUEST = 'VALIDATE_ACCESS_TOKEN_REQUEST';
export const VALIDATE_ACCESS_TOKEN_SUCCESS = 'VALIDATE_ACCESS_TOKEN_SUCCESS';
export const VALIDATE_ACCESS_TOKEN_FAILURE = 'VALIDATE_ACCESS_TOKEN_FAILURE';

// save companyId
export const SAVE_LINKEDIN_COMPANY_REQUEST = "SAVE_LINKEDIN_COMPANY_REQUEST";
export const SAVE_LINKEDIN_COMPANY_SUCCESS = "SAVE_LINKEDIN_COMPANY_SUCCESS";
export const SAVE_LINKEDIN_COMPANY_FAILURE = "SAVE_LINKEDIN_COMPANY_FAILURE";

